import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { AiAddQuestionChangeStrategy } from '../../../../bases';
import { AnswerItem } from '../components';
import styled from '@xstyled/styled-components';
import { Radio } from 'antd';
import { MathEnabledTextComponent, getSize } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledAnswerContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-top: ", ";\n"])), getSize('padding12'));
var StyledAnswerGroup = styled(Radio.Group)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  width: 100%;\n"])), getSize('padding12'));
var StyledAnswerDescription = styled(MathEnabledTextComponent)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 500;\n  color: #1e293b;\n  line-height: ", ";\n  p {\n    margin: 0;\n    display: inline;\n  }\n"])), getSize('typo16'), getSize('padding24'));
export var SingleChoiceAddQuestionStrategy = /*#__PURE__*/function (_AiAddQuestionChangeS) {
  _inherits(SingleChoiceAddQuestionStrategy, _AiAddQuestionChangeS);

  var _super = _createSuper(SingleChoiceAddQuestionStrategy);

  function SingleChoiceAddQuestionStrategy(context) {
    _classCallCheck(this, SingleChoiceAddQuestionStrategy);

    return _super.call(this, context);
  }

  _createClass(SingleChoiceAddQuestionStrategy, [{
    key: "renderAnswerDescription",
    value: function renderAnswerDescription(desc, _beforeDesc, _changed) {
      return /*#__PURE__*/_jsx(StyledAnswerDescription, {
        value: desc
      });
    }
  }, {
    key: "renderAnswers",
    value: function renderAnswers() {
      var _after$answers,
          _after$correctAnswers,
          _after$correctAnswers2,
          _after$correctAnswers3,
          _this = this;

      var after = this.context.after;
      var answers = (_after$answers = after === null || after === void 0 ? void 0 : after.answers) !== null && _after$answers !== void 0 ? _after$answers : [];
      var correctAnswerId = (_after$correctAnswers = after === null || after === void 0 ? void 0 : (_after$correctAnswers2 = after.correctAnswers) === null || _after$correctAnswers2 === void 0 ? void 0 : (_after$correctAnswers3 = _after$correctAnswers2[0]) === null || _after$correctAnswers3 === void 0 ? void 0 : _after$correctAnswers3.answerId) !== null && _after$correctAnswers !== void 0 ? _after$correctAnswers : null;
      return /*#__PURE__*/_jsx(StyledAnswerContainer, {
        children: /*#__PURE__*/_jsx(StyledAnswerGroup, {
          value: correctAnswerId,
          children: answers.map(function (answer, index) {
            var _answer$description;

            return /*#__PURE__*/_jsx(AnswerItem, {
              index: index,
              values: {
                description: _this.renderAnswerDescription((_answer$description = answer.description) !== null && _answer$description !== void 0 ? _answer$description : '', undefined, false),
                isSelected: correctAnswerId === answer.id.toString()
              }
            }, answer.id.toString());
          })
        })
      });
    }
  }]);

  return SingleChoiceAddQuestionStrategy;
}(AiAddQuestionChangeStrategy);